<template>
  <div class="not-find">
    <div style="margin-top: -70px; text-align: center;">
      <img src="./img/401.png" />
      <div style="color: #a5afb5; font-size: 16px; margin-top: -10px;">暂无权限，请联系管理员添加</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "app-error-401"
  }
</script>

<style scoped>
  .not-find {
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
